import { connect } from 'react-redux';
import Feedback from './Feedback';
import { createFeedback, fetchAllFeedback } from '../../../redux/actions/feedback_actions';
import { withRouter } from 'react-router-dom';

const mSTP = state => ({
  notifications: Object.values(state.notifications),
  users: Object.values(state.users),
  feedback: state.feedback,
  currentUserId: state.session.user._id,
  currentUserRole: state.session.user.role,
  currentUser: state.session.user.username
});

const mDTP = dispatch => ({
  createFeedback: (feedback) => dispatch(createFeedback(feedback)),
  fetchAllFeedback: (cancelToken) => dispatch(fetchAllFeedback(cancelToken)),
});

export default withRouter(connect(mSTP, mDTP)(Feedback))
